/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates a category walkthrough guide
 *
 * @module enervee_utils.category_guide
 */
function categoryGuideModalDirective() {
    return {
        restrict: 'E',
        controller: categoryGuideModalController,
        template: require('./categoryGuideModalView.html'),
   };
}
categoryGuideModalController.$inject = [
    '$scope',
    '$timeout',
    'CmsContentService',
    'UtilService',
    'FiltersService',
    'CategoryGuideModalService',
    'AnalyticsService'
];
function categoryGuideModalController(
    $scope,
    $timeout,
    CmsContentService,
    UtilService,
    FiltersService,
    CategoryGuideModalService,
    AnalyticsService
) {

    $scope.steps = CategoryGuideModalService.getStepsToDisplay();
    CmsContentService.retrieveCMSValue($scope, 'next_text', 'base:modals:category_guide_next');
    CmsContentService.retrieveCMSValue($scope, 'finish_text', 'base:modals:category_guide_finish');
    $scope.focusElement = UtilService.focusElement;

    // Is true if there is a current animation, otherwise false, helps prevent the user
    // from clicking to fast
    var currentAnimation = false;
    // Length of the animation. Slightly longer than transition time value (in CSS) to
    // prevent any issues. The time is pulled from Bootstrap's carousel transition:
    // .carousel-inner > .item
    var animationTimer = 800;

    $scope.carouselActiveIndex = 0;
    $scope.siteTitle = UtilService.getSiteSetting('title');
    $scope.bannerLogo = UtilService.getSiteSetting('banner_logo');
    $scope.carouselLastIndex = $scope.steps.length - 1;

    // init filters to have selection on each step
    var filters = {};

    $scope.carouselNextSlide = function(filter) {
        // If an animation is not running, proceed to next slide.
        // If there is an animation running, do nothing.
        if (!currentAnimation) {
            AnalyticsService.reportEvent('Category Walkthrough Clicked', {
                category: CategoryGuideModalService.categoryCode,
                location: 'modal',
                step: $scope.carouselActiveIndex + 1,
                filter: filter
            });
            if ($scope.carouselActiveIndex === $scope.carouselLastIndex) {
                // Close the modal
                $('#modal-category-guide').modal('toggle');
                $scope.filterCategory();
            } else {
                // Go to the next carousel slide
                $scope.carouselActiveIndex++;
                currentAnimation = true;
                $timeout(function () {
                    currentAnimation = false;
                }, animationTimer);
            }
        }
    };

    $('#modal-category-guide').on('hidden.bs.modal', function () {
        // Once the modal is hidden, reset to first slide
        $scope.carouselActiveIndex = 0;
    });

    $scope.setFilter = function (filter) {
        angular.extend(filters, filter);
        $scope.carouselNextSlide(filter);
    };

    // filter category based on guide selection
    $scope.filterCategory = function () {
        AnalyticsService.reportEvent('Category Walkthrough Completed', {
            category: CategoryGuideModalService.categoryCode,
            location: 'modal',
            filters: filters,
        });

        if (angular.equals({}, filters)){
            return;
        }
        FiltersService.filtersOutputCallbacks = [];
        FiltersService.filtersOutputCallbacks.push({
            filter_output: function() {
                return filters;
            },
            is_top_menu_item: false
        } );
        $timeout(function () {
            FiltersService.filterResults();
        }, animationTimer);
    };
}

 module.exports = categoryGuideModalDirective;